import Vue from 'vue';
import VueRouter from 'vue-router';
import { globalStartupGuard, authGuard } from '../helpers/global/session-helper';
import OpenidLogin from '~/pages/auth/OpenidLogin.vue';

Vue.use(VueRouter);

const appRoutes = [
  {
    path: '/',
    name: 'Dashboard',
    component: () => import(/* webpackChunkName: "dashboard" */ '../pages/app-console.vue'),
  },
  {
    path: '/dashboard',
    redirect: '/',
  },
];

const guestRoutes = [
  {
    path: '/login',
    redirect: (route) => {
      return {
        name: 'OpenidLogin',
        query: {
          mode: route.query.mode,
          error: route.query.error,
        },
      };
    },
  },
  {
    path: '/openid_login',
    name: 'OpenidLogin',
    component: OpenidLogin,
    props: (route) => {
      return {
        err: route.query.error,
        mode: route.query.mode,
      };
    },
  },
  {
    // Complete the user invite process.
    // After clicking 'accept' invite, user is prompted to complete their
    // details & set a password.
    path: '/create_password',
    name: 'CreatePassword',
    component: () => import('~/pages/auth/CreatePassword.vue'),
    props: (route) => {
      return {
        app: route.query.app,
        mode: route.query.mode,
        err: route.query.error,
        userId: route.query.userId,
        token: route.query.token,
        email: route.query.email,
        inputFullName: route.query.fullname,
      };
    },
  },
  {
    // Request a password reset
    path: '/forgot_password',
    name: 'ForgotPassword',
    component: () => import('~/pages/auth/ForgotPassword.vue'),
    props: (route) => {
      return {
        app: route.query.app,
        mode: route.query.mode,
        err: route.query.error,
      };
    },
  },
  {
    // Complete the password reset process
    path: '/reset_password',
    name: 'ResetPassword',
    component: () => import('~/pages/auth/ResetPassword.vue'),
    props: (route) => {
      return {
        app: route.query.app,
        mode: route.query.mode,
        err: route.query.error,
        userId: route.query.userId,
        token: route.query.token,
      };
    },
  },
];

guestRoutes.forEach((r) => {
  r.meta = { guest: true };
});

const router = new VueRouter({
  routes: [].concat(guestRoutes, appRoutes),
});

// Auth guard to be implemented
// Install router guard
router.beforeEach((to, from, next) => {
  globalStartupGuard(to, from).then(() => {
    authGuard(to, from, next);
  });
});

export default router;
